import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'facility_line_legal_requirements_when_administering_hiv_aids'

export const dataPointDefinition = {
  retracedId: 'facility_line_legal_requirements_when_administering_hiv_aids',
  name: 'Is the facility in line with legal requirements when administering HIV / AIDS tests during employment?',
  description: 'Consult applicable legal requirements before answering this question.',
  meta: {
    slcpMeta: {
      key: 'wt-dis-33',
      number: 'WT-DIS-21',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wt-dis-33', version: '1.7.0', provider: 'slcp'}],
  sortingId: 37290,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
